import { createFileRoute } from '@tanstack/react-router';
import { HealthExercisesScreen } from '../../screens/health/exercises/HealthExercises';

export const Route = createFileRoute('/health/exercises')({
  component: HealthExercisesScreen,
});
